import { Component, EventEmitter, Output, Input, ChangeDetectorRef, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  private readonly previousStepValue: number;
  private readonly nextStepValue: number;

  @Input() public isBackBtnVisible: boolean;
  @Input() public isNextBtnDisabled: boolean;
  @Output() private pageChanged = new EventEmitter<number>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.previousStepValue = -1;
    this.nextStepValue = 1;
  }

  ngOnInit() {}

  public previousStep(): void {
    this.pageChanged.emit(this.previousStepValue);
  }

  public nextStep(): void {
    this.pageChanged.emit(this.nextStepValue);
  }
}
